import { Component, Input, OnInit } from '@angular/core';
import { JobsService } from 'src/app/modules/instance/services';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';

@Component({
    standalone: false,
    selector: 'app-make-process-idle-button',
    templateUrl: './make-process-idle-button.component.html',
    styleUrls: ['../styles/common-process-action-button.scss']
})
export class MakeProcessIdleButtonComponent implements OnInit {
    @Input()
    public process: ITaskModel;

    constructor(
        private jobsService: JobsService
    ) { }

    ngOnInit(): void { }

    makeIdle() {
        this.jobsService.stopJob(this.process, true);
    }
}
